import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import { __assign } from "tslib";
import { Modal } from 'ant-design-vue';
import t from '@/utils/language';
export default (function (data) {
  var columns = [{
    title: t('关键字'),
    dataIndex: 'keyword'
  }, {
    title: t('错误信息'),
    dataIndex: 'message'
  }];
  var arr = [];
  data.forEach(function (item) {
    item.error_list.forEach(function (child, index) {
      var obj = __assign(__assign({}, child), {
        keyword: item.keyword
      });

      if (index === 0) {
        obj.mergeRow = item.error_list.length;
      }

      arr.push(obj);
    });
  });
  Modal.info({
    title: $t("\u9519\u8BEF\u63D0\u793A"),
    width: 600,
    content: function content(h) {
      return h('a-table', {
        attrs: {
          'data-source': arr,
          bordered: true,
          pagination: false
        },
        props: {
          columns: columns,
          'data-source': arr
        }
      });
    }
  });
});